export const identityAccessModule = "identity-access" as const;

export const roles = ["system-administrator", "financial-administrator"] as const;
export type Role = (typeof roles)[number];

export const SESSION_IDLE_MS = 15 * 60 * 1_000;
export const SESSION_ABSOLUTE_MS = 8 * 60 * 60 * 1_000;
export const ACCESS_CODE_TTL_MS = 30 * 60 * 1_000;
export const WEBAUTHN_CHALLENGE_TTL_MS = 5 * 60 * 1_000;
export const OFFLINE_PIN_ITERATIONS = 600_000;
export const OFFLINE_PIN_FAILURE_LIMIT = 10;
export const DEVICE_CODE_ALPHABET = "23456789ABCDEFGHJKLMNPQRSTUVWXYZ";

export type AccessCodePurpose = "enrollment" | "recovery";

export function normalizeAccessCode(value: string): string {
  return value.toUpperCase().replace(/[^A-Z0-9]/g, "");
}

export function isValidOfflinePin(value: string): boolean {
  return /^\d{8}$/.test(value);
}

export function isSessionActive(createdAtMs: number, lastSeenAtMs: number, nowMs: number): boolean {
  return nowMs - lastSeenAtMs < SESSION_IDLE_MS && nowMs - createdAtMs < SESSION_ABSOLUTE_MS;
}

export function createDeviceCode(randomIndex: () => number): string {
  return Array.from({ length: 5 }, () => {
    const index = randomIndex();
    if (!Number.isInteger(index) || index < 0 || index >= DEVICE_CODE_ALPHABET.length) {
      throw new Error("Device-code entropy source returned an invalid index");
    }
    return DEVICE_CODE_ALPHABET[index];
  }).join("");
}
